'use client';

/**
 * Keycloak authentication helper functions for token management.
 * Used with the Sandbox implicit flow authentication.
 */

/**
 * Revoke the current access token server-side.
 * Called during logout to invalidate tokens with Keycloak.
 */
export async function revokeToken(): Promise<void> {
  try {
    await fetch('/api/auth/revoke', {
      method: 'POST',
      credentials: 'include',
    });
  } catch (err) {
    console.error('[auth] Token revocation failed:', err);
  }
}

/**
 * Refresh tokens using the refresh token stored in cookies.
 * For implicit flow (Electron), this will also accept tokens from Authorization header.
 */
export async function refreshTokens(): Promise<
  { success: true; tokens: { access_token: string } } | { success: false; error: string }
  > {
  try {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.error || 'Token refresh failed',
      };
    }

    return { success: true, tokens: { access_token: data.access_token } };
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : 'Network error',
    };
  }
}
